import React, {
	useEffect
} from 'react';
import './CompletedJobDetails.scss';
import JobAudioFileList from './JobAudioFileList';
import { JobDetails } from '../../models/dto/job';
import { CallDetails } from '../../models/dto/call';
import { EngagementExpandedSummary } from '../../models/dto/engagement';
import {
	useDispatch,
	useSelector
} from 'react-redux';
import { AppState } from '../../store/state/appState';
import { loadEngagementIfMissing } from '../../store/actions/engagementsActions';
import { AppDispatch } from '../../store/actions/appDispatch';
import PageLoadingSpinner from '../PageLoadingSpinner';
import BackToTethrLink from '../BackToTethrLink';

export default function CompletedJobDetails(props: Props) {
	const engagement = useSelector<AppState, EngagementExpandedSummary | undefined>(s => s.engagements.details.get(props.engagementId));
	const dispatch = useDispatch<AppDispatch>();
	
	useEffect(() => {
		dispatch(loadEngagementIfMissing(props.engagementId));
	}, [props.engagementId]);
	
	if (!engagement) {
		return <PageLoadingSpinner />;
	}
	
	return (
		<div className="page-container">
			<h1 className="h1-mb-1 text-center">{props.job.createdWithoutCallManifest ? 'Your calls were successfully uploaded' : 'Job completed'}</h1>

			<div className="completed-job-details__header-sub-text">
				{engagement.showTethrAppIntegration && (
					<React.Fragment>
						<div>Processing time may vary depending on the number of calls in the queue. You will receive an email when your calls are ready.</div>
						{!!engagement.tethrUrl && <div className="completed-job-details__back-to-tethr-link"><BackToTethrLink tethrUrl={engagement.tethrUrl} linkText="Go back to Creovai" /></div>}
					</React.Fragment>
				)}

				{!engagement.showTethrAppIntegration && 'Thank you, Creovai successfully received the following calls.'}
			</div>

			<JobAudioFileList<CallDetails> header="File name" files={getUploadedCalls()} getFilename={c => c.fileName ?? ''} >
				{(c) => (
					<div key={c.id} className="boxed-list__item boxed-list__item_small-text">{c.fileName}</div>
				)}
			</JobAudioFileList>
		</div>
	);
	
	function getUploadedCalls(): CallDetails[] {
		return props.job.calls?.filter(c => !!c.tethrCallId) ?? [];
	}
}

interface Props {
	engagementId: number;
    job: JobDetails;
}
